import { Flex, orderStatusTextToColor, type OrderStatusText } from '@talos/kyoko';
import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const ExecutionCardWrapper = styled.div<{ status: OrderStatusText; attached: boolean }>`
  border-top: solid 4px ${({ status, theme }) => orderStatusTextToColor(status, theme)};
  padding: ${({ theme }) => theme.spacing16}px;
  background: ${({ theme }) => theme.backgroundContent};
  backdrop-filter: blur(10px);
  position: ${({ attached }) => (attached ? 'absolute' : 'relative')};
  bottom: 0;
  width: 100%;
  z-index: 2;
  transition: border 200ms ease;
  animation: ${slideUp} 200ms ease-out forwards;

  > button {
    position: absolute;
    top: ${({ theme }) => theme.spacing8}px;
    right: ${({ theme }) => theme.spacing8}px;
  }
`;

export const Header = styled(Flex)`
  margin-bottom: ${({ theme }) => theme.spacing24}px;
  color: ${({ theme }) => theme.colorTextImportant};
  line-height: 1;
  align-items: center;
  gap: ${({ theme }) => theme.spacing8}px;
`;

export const Label = styled.span`
  padding-right: ${({ theme }) => theme.spacing2}px;
`;

export const Value = styled.span`
  color: ${({ theme }) => theme.colorTextImportant};
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing8}px;

  > *:first-child {
    flex: 1;
  }
`;

export const Section = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing32}px;
`;

export const Footer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing16}px;

  button {
    flex: 1;
  }
`;

export const ParametersSection = styled.div`
  border-left: solid 1px ${({ theme }) => theme.borderColorDivider};
  padding-left: ${({ theme }) => theme.spacing8}px;
  font-size: ${({ theme }) => theme.fontSizeTiny}rem;
`;
